module.exports = __webpack_public_path__ + "static/media/26UNRWA19.b00dac26.jpg";